/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerGoogleSpannerSourceComponent', [
    '$rootScope',
    'DesignerDatabaseBaseSourceComponent',

    function ($rootScope, DesignerDatabaseBaseSourceComponent) {
      function DesignerGoogleSpannerSourceComponent() {
        DesignerDatabaseBaseSourceComponent.apply(this);
      }

      DesignerGoogleSpannerSourceComponent.prototype = new DesignerDatabaseBaseSourceComponent();

      DesignerGoogleSpannerSourceComponent.prototype.getData = function () {
        const data = DesignerDatabaseBaseSourceComponent.prototype.getData.call(this);

        _.extend(data, {});

        return data;
      };

      DesignerGoogleSpannerSourceComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerDatabaseBaseSourceComponent.prototype.setFormData.call(this, data);
      };

      DesignerGoogleSpannerSourceComponent.prototype.setData = function (data) {
        DesignerDatabaseBaseSourceComponent.prototype.setData.call(this, data);
      };

      return DesignerGoogleSpannerSourceComponent;
    },
  ]);
})(window.angular);
